import { useQuery } from "@apollo/client";
import { GET_TIME_ZONES } from "../graphql/queries";

export const useTimeZones = () => {
  const { loading, error, data } = useQuery(GET_TIME_ZONES);

  return {
    loading,
    error,
    timeZones: data?.getTimeZones || [], // Return an empty array if data is undefined
  };
};
export function GetTimezoneInfo(id) {
  const { timeZones } = useTimeZones();
  return timeZones.find((timezone) => timezone.id === id);
}

export function GetTimezoneInfoByTimezone(timezone) {
  const { timeZones } = useTimeZones();
  return timeZones.find((tzone) => tzone.timezone === timezone);
}
